import {
  require_classnames
} from "./chunk-PXJBVWC7.mjs";
import {
  __objRest,
  __spreadProps,
  __spreadValues,
  __toESM
} from "./chunk-WI73T6NA.mjs";

// src/form/error/index.tsx
var import_classnames = __toESM(require_classnames());

// ../../node_modules/@hookform/error-message/dist/index.esm.js
import * as e from "react";

// ../../node_modules/react-hook-form/dist/index.esm.mjs
import React from "react";
var isDateObject = (value) => value instanceof Date;
var isNullOrUndefined = (value) => value == null;
var isObjectType = (value) => typeof value === "object";
var isObject = (value) => !isNullOrUndefined(value) && !Array.isArray(value) && isObjectType(value) && !isDateObject(value);
var compact = (value) => Array.isArray(value) ? value.filter(Boolean) : [];
var isUndefined = (val) => val === void 0;
var get = (obj, path, defaultValue) => {
  if (!path || !isObject(obj)) {
    return defaultValue;
  }
  const result = compact(path.split(/[,[\].]+?/)).reduce((result2, key) => isNullOrUndefined(result2) ? result2 : result2[key], obj);
  return isUndefined(result) || result === obj ? isUndefined(obj[path]) ? defaultValue : obj[path] : result;
};
var VALIDATION_MODE = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
};
var HookFormContext = React.createContext(null);
var useFormContext = () => React.useContext(HookFormContext);
var isWeb = typeof window !== "undefined" && typeof window.HTMLElement !== "undefined" && typeof document !== "undefined";
var defaultOptions = {
  mode: VALIDATION_MODE.onSubmit,
  reValidateMode: VALIDATION_MODE.onChange,
  shouldFocusError: true
};

// ../../node_modules/@hookform/error-message/dist/index.esm.js
var s = function(s2) {
  var t = s2.as, a = s2.errors, m = s2.name, o = s2.message, i = s2.render, l = function(e2, r) {
    if (null == e2)
      return {};
    var n, s3, t2 = {}, a2 = Object.keys(e2);
    for (s3 = 0; s3 < a2.length; s3++)
      r.indexOf(n = a2[s3]) >= 0 || (t2[n] = e2[n]);
    return t2;
  }(s2, ["as", "errors", "name", "message", "render"]), f = useFormContext(), c = get(a || f.formState.errors, m);
  if (!c)
    return null;
  var g = c.message, u = c.types, d = Object.assign({}, l, { children: g || o });
  return e.isValidElement(t) ? e.cloneElement(t, d) : i ? i({ message: g || o, messages: u }) : e.createElement(t || e.Fragment, d);
};

// src/form/error/styles.ts
import { css } from "@emotion/react";
var ErrorWrapperCss = css({
  width: "100%",
  fontSize: "0.75rem",
  fontWeight: "600",
  lineHeight: "1.5",
  color: "#FF696D",
  height: "20px",
  textAlign: "right"
});

// src/form/error/index.tsx
import { Fragment as Fragment2, jsx } from "@emotion/react/jsx-runtime";
var ElementError = (props) => {
  const _a = props, { errors, showErrorBoard, className, name } = _a, rest = __objRest(_a, ["errors", "showErrorBoard", "className", "name"]);
  const classes = (0, import_classnames.default)("pq-form__errors", className);
  const renderError = () => {
    const errorWrapper = (message) => {
      return (showErrorBoard || !!errors) && /* @__PURE__ */ jsx(
        "div",
        __spreadProps(__spreadValues({
          "data-cy": "form-input-error-message",
          className: classes
        }, rest), {
          css: ErrorWrapperCss,
          children: message
        })
      );
    };
    return errorWrapper(/* @__PURE__ */ jsx(s, { errors, name }));
  };
  return /* @__PURE__ */ jsx(Fragment2, { children: renderError() });
};

export {
  ElementError
};
//# sourceMappingURL=chunk-BVWBJ3I4.mjs.map